import type {
  FilesFormatSchemaWithId,
  FilesFormatSchemaWithIdNullable,
} from '@iconik-io/iconik-api/src/services/files';

import { getTrackFromFormat } from './get_track_from_format';
import { isPdfFormat } from './is_pdf_format';
import {
  MEDIA_TYPE_AUDIO,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_PDF,
  MEDIA_TYPE_VIDEO,
  type MediaType,
} from './media_type';

export function getOriginalFormatMediaType(
  originalFormat:
    | FilesFormatSchemaWithId
    | FilesFormatSchemaWithIdNullable
    | undefined,
): MediaType | undefined {
  if (!originalFormat) {
    return undefined;
  }

  const video = getTrackFromFormat(originalFormat, 'VIDEO');
  const image = getTrackFromFormat(originalFormat, 'IMAGE');
  const audio = getTrackFromFormat(originalFormat, 'AUDIO');
  const isPdf = isPdfFormat(originalFormat.metadata ?? undefined);

  if (video) {
    return MEDIA_TYPE_VIDEO;
  }
  if (audio) {
    return MEDIA_TYPE_AUDIO;
  }
  if (image) {
    return MEDIA_TYPE_IMAGE;
  }
  if (isPdf) {
    return MEDIA_TYPE_PDF;
  }

  return undefined;
}
